import React from 'react';

const LiveNow = () => {
    return (
        <div>
           <h1>Live</h1> 
        </div>
    );
};

export default LiveNow;